var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 20h20L12 2 2 20z"}));
}

Triangle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Triangle;

Triangle.default = Triangle;
